export default "__VITE_ASSET__BGkoL3QG__"